import React from "react";
import { css } from "styled-components/macro";
import lstool from "../../utils/localStorage";
import { InfoSection, GrayBox } from "../UI/profile";
import { ListItemSection } from "./../UI/profile";

export default function Profile(props) {
  const userData = { id: lstool.get(), ...JSON.parse(lstool.get("userData")) };
  const LogOut = () => {
    lstool.remove();
    props.history.replace("/login");
  };
  return (
    <div
      css={css`
        padding: 15px;
      `}
    >
      <InfoSection
        name={userData.name}
        status={JSON.parse(userData.AccessToImport)}
        userId={userData.id}
      ></InfoSection>
      <ListItemSection
        icon={{ icon: "md md-power", color: "var(--failed)" }}
        click={LogOut}
        title="خروج از حساب کاربری"
      ></ListItemSection>
    </div>
  );
}
